import { Component } from '@angular/core';

@Component({
  selector: 'stc-apps-security-icon',
  templateUrl: './security-icon.component.svg',
  styleUrls: ['./security-icon.component.scss'],
  standalone: true,
})
export class SecurityIconComponent {}
